<p>Esta es mi ip: {{ ipAddress?.ip }}</p>